// src/components/pages/SupportPage/SupportPage.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserData } from '../../services/useUserData';
import { notificationService } from '../../services/notificationService';
import Loader from '../../widgets/Loader/Loader';
import BackgroundCanvasWithoutRadar from '../../widgets/canvas/BackgroundCanvasWithoutRadar';
import { SupportIcons } from '../../assets/images/supportIcons';
import './SupportPage.scss';

function SupportPage() {
    const navigate = useNavigate();
    const { telegramId, loading: userLoading } = useUserData();
    const [isLoading, setIsLoading] = useState(true);
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        const tg = (window as any).Telegram?.WebApp;
        if (tg) {
            tg.ready();
            tg.expand();
            tg.setHeaderColor?.('#000000');
            tg.setBackgroundColor?.('#000000');
        }

        // Имитация загрузки данных страницы
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    // Подписываемся на обновления непрочитанных сообщений
    useEffect(() => {
        if (!userLoading && telegramId) {
            // Подписываемся на обновления
            const unsubscribe = notificationService.subscribe((count) => {
                setUnreadCount(count);
            });

            return () => {
                unsubscribe();
            };
        }
    }, [telegramId, userLoading]);

    // Функция для перехода в чат с отметкой прочитанных
    const handleOpenChat = async () => {
        // Если есть непрочитанные, отмечаем их как прочитанные
        if (unreadCount > 0) {
            await notificationService.markAsRead();
        }
        navigate('/support-chat');
    };

    if (userLoading || isLoading) {
        return (
            <div className="tg-app">
                <BackgroundCanvasWithoutRadar />
                <div className="support-page loading">
                    <div className="loader"><Loader /></div>
                </div>
            </div>
        );
    }

    return (
        <div className="tg-app">
            <BackgroundCanvasWithoutRadar />

            <div className="support-page">
                {/* Герой блок с иконкой */}
                <div className="support-hero">
                    <div className="hero-icon">
                        <SupportIcons.support />
                    </div>
                    <div className="hero-title">Поддержка</div>
                    <div className="hero-subtitle">Получите ответы на популярные вопросы или обратитесь к нам за помощью</div>
                </div>

                {/* Блок 1: Часто задаваемые вопросы */}
                <div className="support-block" onClick={() => navigate('/faq')}>
                    <div className="block-icon">
                        <SupportIcons.faq />
                    </div>
                    <div className="block-content">
                        <div className="block-title">Часто задаваемые вопросы</div>
                        <div className="block-subtitle">Ответы на часто задаваемые вопросы</div>
                    </div>
                    <span className="block-arrow">
                        <SupportIcons.chevronRight />
                    </span>
                </div>

                {/* Блок 2: Установка на другом устройстве */}
                <div className="support-block" onClick={() => navigate('/install')}>
                    <div className="block-icon">
                        <SupportIcons.device />
                    </div>
                    <div className="block-content">
                        <div className="block-title">Инструкции для устройств</div>
                        <div className="block-subtitle">Подробная инструкция для установки</div>
                    </div>
                    <span className="block-arrow">
                        <SupportIcons.chevronRight />
                    </span>
                </div>

                {/* Блок 3: Поддержка с бейджем */}
                <div className={`support-block ${unreadCount > 0 ? 'has-unread' : ''}`} onClick={handleOpenChat}>
                    <div className="block-icon">
                        <SupportIcons.chat />
                        {unreadCount > 0 && (
                            <span className="support-block-badge">
                                {unreadCount > 99 ? '99+' : unreadCount}
                            </span>
                        )}
                    </div>
                    <div className="block-content">
                        <div className="block-title">
                            Поддержка
                        </div>
                        <div className="block-subtitle">
                            {unreadCount > 0
                                ? `У вас ${unreadCount} ${unreadCount === 1 ? 'новое сообщение' : unreadCount < 5 ? 'новых сообщения' : 'новых сообщений'}`
                                : 'Связаться с поддержкой'}
                        </div>
                    </div>
                    <span className="block-arrow">
                        <SupportIcons.chevronRight />
                    </span>
                </div>
            </div>
        </div>
    );
}

export default SupportPage;